import { createContext } from 'react';
import {ID, Response} from '../../../../../_dashboard/helpers'

export interface ThemeTranslation {
  Theme_id?: ID;
  _id?:ID
  language: string;
  name: string;
}

export interface Theme {
  _id?: ID;
  translations: ThemeTranslation[];

 
}




export const initialTheme: Theme = {

  translations: [
    {
 
      language: '',
      name: '',
      
    },
  ],
};
export type ThemesQueryResponse = Response<Array<Theme>>;
export type QueryResponseThemeContextProps<T> = {
  dataResponse?: Response<Array<T>> | undefined
  refetchData: () => void
  isLoading: boolean
  query: any
}
export function createThemeResponseContext<T>(initialState: QueryResponseThemeContextProps<T>) {
  return createContext(initialState)
}
export const initialThemeQueryResponse = { refetchData: () => { }, isLoading: false, query: '' }